export default __webpack_public_path__ + "static/media/WordWork_15.27ce9733.png";